/**
 * Theme Provider Wrapper for Omni UI
 * Matches GCMS-ADMIN usage pattern with fallback support
 */

'use client';

import * as React from 'react';
// When omni-ui is available, use this import:
// import { ThemeProvider as OmniThemeProvider } from '@pw-tech/omni-ui'

interface ThemeProviderProps {
  children: React.ReactNode;
  theme?: string;
  defaultTheme?: string;
  storageKey?: string;
  attribute?: string;
  disableTransitionOnChange?: boolean;
}

/**
 * Theme Provider that matches GCMS-ADMIN pattern
 * Uses omni-ui ThemeProvider when available, fallback when not
 */
export const ThemeProvider: React.FC<ThemeProviderProps> = ({
  children,
  // theme,
  // defaultTheme = 'light',
  // storageKey = 'theme',
  // attribute = 'class',
  // disableTransitionOnChange = false,
}) => {
  const [mounted, setMounted] = React.useState(false);

  React.useEffect(() => {
    setMounted(true);
  }, []);

  // Prevent hydration mismatch during SSR
  if (!mounted) {
    return <>{children}</>;
  }

  // When omni-ui is available, use it (matches GCMS-ADMIN pattern):
  // return (
  //   <OmniThemeProvider
  //     theme={theme}
  //     defaultTheme={defaultTheme}
  //     storageKey={storageKey}
  //     attribute={attribute}
  //     disableTransitionOnChange={disableTransitionOnChange}
  //   >
  //     {children}
  //   </OmniThemeProvider>
  // )

  // Fallback implementation when omni-ui is not available
  return <div data-theme-provider="fallback">{children}</div>;
};
